import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  createCustomerUser,
  getCustomerCompanyList,
  updateCustomerTrackingUser,
  ResendEmailConfirmation,
  _createCustomerUserSuccess,
} from '../../redux/tracking-manager';
import { getRecipientUsersList } from '../../redux/recipient-tracking';

import Tooltip from './Tooltip';
import EditModal from './EditModal';
import RegisterModal from './RegisterModal';
import TrackingTable from './TrackingTable';
import ConfirmationModal from './ConfirmationModal';

import Toggle from '../../components/Toggle';
import LoadMask from '../../components/LoadMask';
import SubHeader from '../../components/SubHeader';

import Mask from '../../utils/Mask';
import { RemoveSpaces } from '../../utils/text-helper';

import {
  Header,
  StyledSearch,
  StyledButton,
  ToolbarContainer,
  TableRegister,
  RegisterSituation,
  RegisterExpiredLink,
  TooltipStyled,
} from './styles';

class RecipientTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModal: false,
      showEditModal: false,
      showConfirmationModal: {
        open: false,
        data: null,
      },

      currentUser: {},
    };

    this.onRenderCell = this.onRenderCell.bind(this);
    this.handleAddModal = this.handleAddModal.bind(this);
    this.handleEditModal = this.handleEditModal.bind(this);
    this.handleResendEmail = this.handleResendEmail.bind(this);
    this.handleCloseModalCreate = this.handleCloseModalCreate.bind(this);
    this.handleConfirmationModal = this.handleConfirmationModal.bind(this);
    this.handleDispatchAfterAction = this.handleDispatchAfterAction.bind(this);
    this.handleCreateNewUser = this.handleCreateNewUser.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  tableConfig = {
    tableHeaders: [
      {
        name: 'Name',
        label: 'Nome',
        boldPrimary: true,
      },
      {
        name: 'Phone',
        label: 'Telefone',
      },
      {
        name: 'Email',
        label: 'E-mail',
      },
      {
        name: 'ds_RazaoSocial',
        label: 'Empresa',
      },
      {
        name: 'lastLogin',
        label: 'Último acesso',
      },
      {
        name: 'cnpjs',
        label: 'CNPJ/CPF',
        width: '180',
      },
      {
        name: 'Cadastro',
        label: 'Cadastro',
      },
      {
        name: 'HasTracking',
        label: 'Rastreio',
      },
    ],
    tableActions: [
      {
        name: 'edit',
        label: 'Editar',
        iconName: 'mode_edit',
        actionFn: data => this.handleEditModal(data),
      },
    ],
  };

  async handleCreateNewUser(data) {
    const { name, email, phone, company, trackingActive } = data;
    const { dispatch } = this.props;

    if ((name, email, phone, company)) {
      await dispatch(
        createCustomerUser(
          {
            name,
            email,
            phone,
            trackingActive,
            taxNumber: company.cd_CGCCPF,
          },
          () => {
            this.handleDispatchAfterAction();
            this.handleAddModal();
          },
        ),
      );
    }
  }

  async handleSubmitChangeTracking() {
    const { dispatch, loggedCompanyId } = this.props;

    await dispatch(
      updateCustomerTrackingUser({
        userId: this.state.showConfirmationModal.data.Id,
        hasTracking: !this.state.showConfirmationModal.data.HasTracking,
      }),
    );

    this.setState({ showConfirmationModal: { open: false, data: null } });
    dispatch(getRecipientUsersList({ companyId: loggedCompanyId, page: 1 }));
  }

  handleEditModal(data) {
    this.setState({ currentUser: data, showEditModal: true });
  }

  handleAddModal() {
    this.setState(state => {
      return { showAddModal: !state.showAddModal };
    });
  }

  handleConfirmationModal(value) {
    this.setState({ showConfirmationModal: { open: true, data: value } });
  }

  handleResendEmail(id) {
    const { dispatch } = this.props;
    dispatch(ResendEmailConfirmation({ userId: id }));
  }

  handleCloseModalCreate() {
    const { dispatch } = this.props;
    dispatch(_createCustomerUserSuccess());

    this.setState({ showAddModal: false });
  }

  onRenderCell = (column, value, row) => {
    switch (column) {
      case 'Phone': {
        return Mask.tel(value);
      }

      case 'Cadastro': {
        return (
          <TableRegister status={value}>
            {value === 'Ativado' && (
              <RegisterSituation>
                <span>{value}</span>
              </RegisterSituation>
            )}
            {value === 'Pendente' && (
              <RegisterSituation>
                <span>{value}</span>
                <Tooltip text="Para garantir a segurança dos dados, o rastreio de pedidos é disponibilizado apenas para destinatários autorizados por você. Ao adicionar um contato, ele receberá um link no e-mail para ativar seu cadastro.">
                  <RegisterExpiredLink
                    onClick={() => this.handleResendEmail(row.Id)}
                  >
                    reenviar link
                  </RegisterExpiredLink>
                </Tooltip>
              </RegisterSituation>
            )}
            {value === 'Prazo expirado' && (
              <RegisterSituation>
                <span>{value}</span>
                <Tooltip text="O rastreio para destinatários permite que contatos cadastrados acompanhem o rastreio dos seus pedidos em tempo real.">
                  <RegisterExpiredLink
                    onClick={() => this.handleResendEmail(row.Id)}
                  >
                    reenviar link
                  </RegisterExpiredLink>
                </Tooltip>
              </RegisterSituation>
            )}
          </TableRegister>
        );
      }

      case 'cnpjs': {
        let formatedList;
        const arrayOfCnpj = JSON.parse(value);

        if (
          arrayOfCnpj.length === 1 &&
          RemoveSpaces(arrayOfCnpj[0]).length === 11
        ) {
          formatedList = Mask.cpf(RemoveSpaces(arrayOfCnpj[0]));
        } else {
          // eslint-disable-next-line no-mixed-operators
          formatedList = arrayOfCnpj.length === 1 && `${Mask.cnpj(arrayOfCnpj[0])}` ||
            arrayOfCnpj.length === 2 && `${Mask.cnpj(arrayOfCnpj[0])}, ${Mask.cnpj(arrayOfCnpj[1])}` || 
            arrayOfCnpj.length === 3 && `${Mask.cnpj(arrayOfCnpj[0])}, ${Mask.cnpj(arrayOfCnpj[1])}, ${Mask.cnpj(arrayOfCnpj[2])}` ||
            arrayOfCnpj.length >= 4 && (
              <TooltipStyled text={arrayOfCnpj.map((cnpjItem, index) => (
                  <>
                    {index < arrayOfCnpj.length - 1 ? (
                      <>
                        {Mask.cnpj(cnpjItem)},
                        <br/>
                      </>
                    ) : (
                      Mask.cnpj(cnpjItem)
                    )}
                  </>
                )
              )}>
                <span>
                  {Mask.cnpj(arrayOfCnpj[0])}, {Mask.cnpj(arrayOfCnpj[1])}, {Mask.cnpj(arrayOfCnpj[2])}...
                </span>
              </TooltipStyled>
            )
        }
        return formatedList;
      }

      case 'HasTracking': {
        return (
          <Toggle
            isChecked={value}
            onChange={() => this.handleConfirmationModal(row)}
            small
          />
        );
      }

      default:
        return value;
    }
  };

  componentDidMount() {
    const { dispatch, loggedCompanyId } = this.props;
    dispatch(getRecipientUsersList({ companyId: loggedCompanyId, page: 1 }));
    dispatch(getCustomerCompanyList());
  }

  onSearch(query) {
    const { dispatch, loggedCompanyId } = this.props;
    dispatch(
      getRecipientUsersList({
        name: query,
        companyId: loggedCompanyId,
        page: 1,
      }),
    );
  }

  handleDispatchAfterAction() {
    const { dispatch, loggedCompanyId } = this.props;
    dispatch(getRecipientUsersList({ companyId: loggedCompanyId, page: 1 }));
    dispatch(getCustomerCompanyList());
  }

  render() {
    const {
      dispatch,
      recipientUsersList,
      loggedCompanyId,
      customerCompaniesList,
      customerCompaniesFetching,
      customerUser,
    } = this.props;

    if (recipientUsersList.isFetching) return <LoadMask text="Carregando" />;

    return (
      <React.Fragment>
        {customerUser.isFetching && (
          <LoadMask zIndex={2000} text="Carregando" />
        )}
        <div className="luft-tracking">
          <Header>
            <SubHeader title="Tracking Destinatário" />
          </Header>
          <div className="luft-tracking-content">
            <ToolbarContainer>
              <StyledSearch
                placeholder="Buscar"
                onSearch={query => this.onSearch(query)}
              />

              <StyledButton skin="primary" onClick={this.handleAddModal}>
                Adicionar
              </StyledButton>
            </ToolbarContainer>

            <TrackingTable
              dispatch={dispatch}
              errorMessage={null}
              data={recipientUsersList.data}
              onRenderCell={this.onRenderCell}
              loggedCompanyId={loggedCompanyId}
              headers={this.tableConfig.tableHeaders}
              actions={this.tableConfig.tableActions}
              pageLimit={recipientUsersList.pageLimit || 10}
              totalItems={recipientUsersList.totalItems || 0}
              currentPage={recipientUsersList.currentPage || 1}
              onSave={() => console.log('salvar')}
              onCancel={() => console.log('cancel')}
            />
          </div>
        </div>

        <RegisterModal
          dispatch={dispatch}
          open={this.state.showAddModal}
          companiesList={customerCompaniesList}
          companiesFetching={customerCompaniesFetching}
          handleCreateNewUser={this.handleCreateNewUser}
          onClose={() => this.handleCloseModalCreate()}
        />

        <EditModal
          dispatch={dispatch}
          open={this.state.showEditModal}
          currentUser={this.state.currentUser}
          companiesList={customerCompaniesList}
          companiesFetching={customerCompaniesFetching}
          onClose={() => this.setState({ showEditModal: false })}
          onSubmit={() => {
            this.handleDispatchAfterAction();
            this.setState({ showEditModal: false });
          }}
        />

        <ConfirmationModal
          open={this.state.showConfirmationModal.open}
          onClose={() =>
            this.setState({
              showConfirmationModal: { open: false, data: null },
            })
          }
          onSubmit={() => this.handleSubmitChangeTracking()}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    recipientUsersList: state.recipientTracking.recipientUsersList,
    customerCompaniesList: state.trackingManager.customerCompanyList.data,
    customerCompaniesFetching: state.trackingManager.customerCompanyList.isFetching,
    loggedCompanyId: state.auth.activeCompanyId,
    customerUser: state.trackingManager.customerUser,
  };
}

export default connect(mapStateToProps)(RecipientTracking);
